import { render, staticRenderFns } from "./ZahnwerkstattAGBPage.vue?vue&type=template&id=3a0b6e57&scoped=true"
import script from "./ZahnwerkstattAGBPage.vue?vue&type=script&lang=js"
export * from "./ZahnwerkstattAGBPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0b6e57",
  null
  
)

export default component.exports